import { openTab } from "@/utils/tabStore";
import { checkLogin } from "@/utils/tool";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'
NProgress.configure({
  ease: "ease",
  speed: 500,
})
const RouterGuard = (router) => {
    router.beforeEach((to,form,next)=>{
        NProgress.start()
        console.log(to,form)
        const name = to.name;
        if(to.query && to.query.state){
            checkLogin(to.query.state)
            return next(false)
        }else if(name){
            openTab(to)
            next()
        }
        // if(to.path!=form.path){
        //     window.location.href = to.path
        // }
       
    })
    router.afterEach((to,form)=>{
        NProgress.done()
    })
}

export default RouterGuard;